document.addEventListener("DOMContentLoaded", function(event) {
    var askedPage = 1;    
    var cssAdded = false;
    async function loadMoreProducts(loadMore, ProductList) {
        askedPage++;
        let sort = loadMore.dataset.sort;
        let tags = loadMore.dataset.tags;

        fetch(window.location.pathname + "/" + tags + "?sections=standalone-products-collection&sort_by=" + sort + "&page=" + askedPage)        
            .then(response => response.json())
            .then(data => {                
                let html = document.createElement('div');
                html.innerHTML = data['standalone-products-collection'];
                let products = html.querySelectorAll('.Grid__Cell');
                if (products.length > 0) {
                    console.log('Loading ' + products.length + ' products.');
                    window.scrollTo(0, window.scrollY);
                    ProductList.append(...products);     
                    if (products.length < loadMore.dataset.perpage) {
                        loadMore.style.display = 'none';
                    }           
                } else {
                    loadMore.style.display = 'none';
                }
            })
            .catch(e => {
                console.error(e);
            });
    }

    let loadMore = document.getElementById('load_more_products');
    if (loadMore) {
        loadMore.addEventListener('click', async function (e){
            if (!cssAdded) {
                const style = document.createElement("style");
                style.innerHTML = '.ProductList .ProductItem {visibility: inherit !important; opacity: 1; transform: matrix(1, 0, 0, 1, 0, 0);}';
                document.head.appendChild(style);
                cssAdded = true;
            }
            let ProductList = document.getElementsByClassName('ProductList');
            const loadingProducts = await loadMoreProducts(this, ProductList[0]);
        });
    }
    
    document.addEventListener('theme:loading:end', async function (e) {
        askedPage = 1;
        let loadMore = document.getElementById('load_more_products');
        if (loadMore) {
            if (!cssAdded) {
                const style = document.createElement("style");
                style.innerHTML = '.ProductList .ProductItem {visibility: inherit !important; opacity: 1; transform: matrix(1, 0, 0, 1, 0, 0);}';
                document.head.appendChild(style);
                cssAdded = true;
            }
            loadMore.addEventListener('click', async function (e){
                let ProductList = document.getElementsByClassName('ProductList');
                const loadingProducts = await loadMoreProducts(this, ProductList[0]);
            });
        }
    });
});